import { NotificationMapper } from "@/domain/mappers";
import { PushNotificationResponse } from "../dtos/responses";
import moment from "moment";
import { PushNotification } from "@/domain/entities";

export class NotificationMapperImpl implements NotificationMapper<PushNotificationResponse> {
  toDomain(data: PushNotificationResponse): PushNotification {
    return {
      ...data,
      date: this.formatDate(data.created_at),
    };
  }

  private formatDate = (date: string) => {
    const yesterday = moment().subtract(1, "day").format("DD/MM/YYYY");
    const today = moment().format("DD/MM/YYYY");
    const time = moment(date).format("hh:mm");

    let finalDate = moment(date).format("DD/MM/YYYY");

    if (today == finalDate) {
      finalDate = "hoje";
    }

    if (yesterday == finalDate) {
      finalDate = "ontem";
    }

    return `${finalDate} • ${time}`;
  };
}
